import { now as dateNow } from 'core-framework/util/datetime/date';
import { IMeasurement, IMeasurementTags } from '@agoda/messaging-client';
import { MessageType } from 'core/messaging/Messaging.types';
import { ActivitiesMessagingClient } from 'core/messaging/ActivitiesMessagingClient';
import { getBootstrapConfig, hasPerformance, performanceNow } from 'core/window/windowService';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';

export const start = () => {
    return hasPerformance() ? performanceNow() : dateNow();
};

export const send = (name: string, measurement: number, pageTypeId: ActivitiesPageTypes, count = 1, tags: IMeasurementTags = {}, isGeneric = false) => {
    if (isGeneric) {
        tags.platform = 'activities';
    }
    const config = getBootstrapConfig();
    tags.botName = config.requestProfile?.knownBotName || 'na';
    if (!tags.pageTypeId) tags.pageTypeId = String(pageTypeId);
    if (!tags.deviceType) tags.deviceType = config.userDevice.deviceType;
    if (!tags.whiteLabelId) tags.whiteLabelId = String(config.pageConfig.whitelabelid);

    const message = ActivitiesMessagingClient.create(MessageType.Measurement, {
        measurement,
        count,
        tags,
        name: !isGeneric ? `fe.activities.${name}` : name,
    });
    ActivitiesMessagingClient.send(message);
};

export const finish = (name: string, started: number, pageTypeId: ActivitiesPageTypes, tags: IMeasurementTags = {}, isGeneric = false) => {
    const finished = start();
    const timeTaken = Math.round(finished - started);

    send(name, timeTaken, pageTypeId, 1, tags, isGeneric);
};

export const sendMeasurement = (measurement: IMeasurement, pageTypeId: ActivitiesPageTypes) => {
    send(measurement.name, measurement.measurement, pageTypeId, measurement.count, measurement.tags, true);
};

export const count = (name: string, measurement: number, pageTypeId: ActivitiesPageTypes, tags: IMeasurementTags = {}, isGeneric = false) =>
    send(name, measurement, pageTypeId, pageTypeId, tags, isGeneric);
